<template>

  <div>

    <div class="main">

      <div class="container">            
            
            <h3 class="tab-content-heading"><font-awesome-icon icon="star" /> New Listing on Xmarine</h3>

            <div v-if="!started">

              <div v-if="user" class="notification">
                <h4 class="centered">Before you start...</h4>

                <ul>
                  <li><font-awesome-icon icon="location-arrow" /> The more information you can offer, the more likely the right buyer will find your item.</li>
                  <li><font-awesome-icon icon="cloud" /> At any stage you can hit the "Save for Later" button on the Review tab.</li>
                  <li><font-awesome-icon icon="users" /> The more friends you tell about Xmarine, the more potential buyers there will be to buy items like yours, so spread the word!</li>
                  <li><font-awesome-icon icon="exclamation-triangle" /> Keep an eye out for the colour red - this indicates <span class="red">a missing field!</span></li>
                  <li><font-awesome-icon icon="comments" /> The success of Xmarine will depend heavily on feedback and ideas from you, our new and growing group of customers, so please share your thoughts, ideas and feedback anytime you see the feedback icon like this:</li>
                </ul>
                <div @click="showFeedback = true" class="example-comment"><font-awesome-icon icon="comments" /></div>

                <div class="clear"></div>

              </div>

              <div v-if="!user" class="login-warning">
                <h3>You do need to be a logged in user to create a listing.</h3>
                <h4>Please log in below or create a free user account in just a few seconds.</h4>
              </div>
              <div v-if="!user" class="buttons centered">
                <span class="button is-primary is-medium" @click="showQuickSignin = true"><font-awesome-icon icon="user" />&nbsp; Quick Log In</span>
                <span class="button is-info is-medium" @click="showQuickSignup = true"><font-awesome-icon icon="pen" />&nbsp; Quick Register</span>
              </div>

              <div v-if="user" class="buttons centered">
                <span class="button is-primary" @click="started = true"><font-awesome-icon icon="location-arrow" />&nbsp;Let's create your listing</span>
                <span class="social-icon"><font-awesome-icon :icon="['fab', 'facebook-square']"></font-awesome-icon></span>
              </div>

              <div class="spacer s90"></div>

            </div>

            <customer-feedback v-if="showFeedback" :question="feedbackQuestion" :choices="feedbackChoices" :responseType="feedbackSingleResponse" v-on:feedbackCancelled="feedbackCancelled()"></customer-feedback>


            <div v-if="started">
              <hr>
              <div class="top-level">
                <h4>What would you like to list?</h4>
                <div class="type" :class="{item: selectedType == 'item'}" @click="updateType('item')"><span>an item</span></div>
                <div class="type" :class="{service: selectedType == 'service'}" @click="updateType('service')"><span>a service</span></div>
                <div class="type" :class="{job: selectedType == 'job'}" @click="updateType('job')"><span>a<br>job</span></div>
              </div>
              <!-- <div class="buttons centered">
                <button :disabled="selectedType == ''" @click="toListingPage()" class="button is-primary is-medium">
                  <font-awesome-icon icon="location-arrow" />&nbsp; {{selectedType == '' ? 'Choose a listing type' : 'Add your ' + selectedType + ' information'}}
                </button>
              </div> -->
            </div>


            <quick-signin v-if="showQuickSignin" v-on:signinCancelled="signinCancelled()" v-on:signin="signinSuccess()"></quick-signin>

            <quick-signup v-if="showQuickSignup" v-on:signupCancelled="signupCancelled()" v-on:signup="signupSuccess()" v-on:readTerms="readTerms()"></quick-signup>



            <simple-modal title="Xmarine Terms of Use" v-on:closed="showTermsModal = false"  v-if="showTermsModal">
              <p>Please take the time to read these terms and conditions. By using Our Website and the Services and information offered on Our Website, you are agreeing to these terms and conditions.</p>
              <p>If you purchase products through Xmarine, there will be additional terms and conditions relating to the purchase.  Please make sure you agree with these terms and conditions, which you will be directed to read prior to making your purchase.</p>
              <h4>Definitions</h4>
              <p><strong>Services</strong> means the cloud based Safety Management System tools provided by Xmarine. </p>
              <p><strong>the Website</strong> means the web app located at www.xmarine.com.au.</p>
              <p><strong>We / Us</strong> etc means Xmarine Pty Ltd and any holding companies, affiliates, employees, officers, agents or assigns.</p>
              <h4>Accuracy of content</h4>
              <p>We have taken proper care and precautions to ensure that the information we provide on this Website is accurate.  However, we cannot guarantee, nor do we accept any legal liability arising from or connected to, the accuracy, reliability, currency or completeness of anything contained on this Website or on any linked site.</p>
              <p>The information contained on this Website should not take the place of professional advice or proper due diligence and care. </p>
              <h4>Use</h4>
              <p>The Website is made available for your use on your acceptance and compliance with these terms and conditions.  By using this Website, you are agreeing to these terms and conditions.</p>
              <p>You agree that you will use this website in accordance with all applicable local, state, national and international laws, rules and regulations.</p>
              <p>You agree that you will not use, nor will you allow or authorise any third party to use, the Website for any purpose that is unlawful, defamatory, harassing, abusive, fraudulent or obscene way or in any other inappropriate way or in a way which conflicts with the Website or the Services.</p>
              <p>If you contribute to our forum (if any) or make any public comments on this Website which are, in our opinion, unlawful, defamatory, harassing, abusive, fraudulent or obscene or in any other way inappropriate or which conflict with the Website or the Services offered, then we may at our discretion, refuse to publish such comments and/or remove them from the Website.</p>
              <p>We reserve the right to refuse or terminate service to anyone at any time without notice or reason.</p>
              <h4>Passwords and logins</h4>
              <p>You are responsible for maintaining the confidentiality of your passwords and login details and for all activities carried out under your password and login.</p>
              <h4>Indemnification for loss or damage</h4>
              <p>You agree to indemnify Us and hold Us harmless from and against any and all liabilities or expenses arising from or in any way related to your use of this Website or the Services or information offered on this Website, including any liability or expense arising from all claims, losses, damages (actual and consequential), suits, judgments, litigation costs and solicitors fees of every kind and nature incurred by you or any third parties through you.</p>
              <h4>Intellectual property and copyrights</h4>
              <p>We hold the copyright to the content of this Website, including all uploaded files, layout design, data, graphics, articles, file content, codes, news, tutorials, videos, reviews, forum posts and databases contained on the Website or in connection with the Services. You must not use or replicate our copyright material other than as permitted by law.  Specifically, you must not use or replicate our copyright material for commercial purposes unless expressly agreed to by Us, in which case we may require you to sign a Licence Agreement.  </p>
              <p>If you wish to use content, images or other of our intellectual property, you should submit your request to us at the following email address: <strong>help@Xmarine.com.au</strong></p>
              <h4>Trademarks</h4>
              <p>Any trademarks and logos contained on this Website will be the trademarks of Xmarine Pty Ltd or its parent company. Use of these trademarks is strictly prohibited except with Our express, written consent.</p>
              <h4>Links to external websites</h4>
              <p>This Website may contain links that direct you outside of this Website.  These links are provided for your convenience and are not an express or implied indication that we endorse or approve of the linked Website, it’s contents or any associated website, product or service.  We accept no liability for loss or damage arising out of or in connection with your use of these sites.  </p>
              <p>You may link to our articles or home page.  However, you should not provide a link which suggests any association, approval or endorsement on our part in respect to your website, unless we have expressly agreed in writing.  We may withdraw our consent to you linking to our site at any time by notice to you.</p>
              <h4>Limitation of Liability</h4>
              <p>We take no responsibility for the accuracy of any of the content or statements contained on this Website or in relation to our Services.  Statements made are by way of general comment only and you should satisfy yourself as to their accuracy.  Further, all of our Services are provided without a warranty with the exception of any warranties provided by law.  We are not liable for any damages whatsoever, incurred as a result of or relating to the use of the Website or our Services.</p>
              <h4>Confidentiality</h4>
              <p>All personal information you give us will be dealt with in a confidential manner in accordance with our Privacy Policy.  However, due to circumstances outside of our control, we cannot guarantee that all aspects of your use of this Website will be confidential due to the potential ability of third parties to intercept and access such information.</p>
              <h4>Governing Law</h4>
              <p>These terms and conditions are governed by and construed in accordance with the laws of Australia.  Any disputes concerning this website are to be resolved by the courts having jurisdiction in Australia. </p>
              <p>We retain the right to bring proceedings against you for breach of these Terms and Conditions, in your country of residence or any other appropriate country or jurisdiction.</p>

            </simple-modal>





      </div>

    </div>

  </div>
  

</template>



<script>

  import { slider, slideritem } from 'vue-concise-slider';
  import { db } from '../../main.js';
  import firebase from 'firebase/app';
  import 'firebase/auth'; 
  import 'firebase/firestore';
  import NProgress from 'nprogress';
  const ListingProgress = () => import('../reusables/ListingProgress.vue');
  const CustomerFeedback = () => import('../reusables/CustomerFeedback.vue');
  const QuickSignin = () => import('../reusables/QuickSignin.vue');
  const QuickSignup = () => import('../reusables/QuickSignup.vue');
  const SimpleModal = () => import('../reusables/SimpleModal.vue');
  
  export default {

    components: {
      CustomerFeedback,
      ListingProgress,
      QuickSignin,
      QuickSignup,
      SimpleModal,
    },
    mounted() {
      firebase.auth().onAuthStateChanged(this.onUserLogin);
    },
    computed: {
      user() {
        return this.$store.getters.getUser;
      },
    },
    data() {
      return {
        firebaseid: '',
        showFeedback: false,
        feedbackQuestion: 'How do you like Xmarine so far?',
        feedbackChoices: [
          {selected: false, title: 'Not sure it\'s for me'},
          {selected: false, title: 'I\'m getting the hang of it'},
          {selected: false, title: 'I love it!'},
        ],
        feedbackSingleResponse: true,
        selectedType: '',
        started: false,
        showQuickSignin: false,
        showQuickSignup: false,
        showTermsModal: false,

      }
    },

    methods: {

      onUserLogin: function(user) {
        if (user) {
          this.firebaseid = user.uid;
        }
      },

      close() {
        this.showFeedback = false;
      },

      feedbackCancelled() {
        this.showFeedback = false;
      },

      updateType(type) {
        this.selectedType = type;
        let self = this;
        this.$router.push({ 
          name: 'NewListingDetails', 
          params: { 
            listingType: self.selectedType == '' ? 'item' : self.selectedType
          } 
        });
      },

      toListingPage() {
        let self = this;
        this.$router.push({ 
          name: 'NewListingDetails', 
          params: { 
            listingType: self.selectedType == '' ? 'item' : self.selectedType
          } 
        });
      },

      signinSuccess() {
        this.showQuickSignin = false;
      },

      signinCancelled() {
        this.showQuickSignin = false;
      },

      signupSuccess() {
        this.showQuickSignup = false;
      },

      signupCancelled() {
        this.showQuickSignup = false;
      },

      readTerms() {
        this.showQuickSignup = false;
        this.showTermsModal = true;
      }



    }

  }


</script>



<style lang="scss" scoped>
  
  .notification {
    text-align: left;
    padding: 2rem;
    margin-top: 2rem;
    h4 {
      margin-bottom: 0.6rem;
      color: deepskyblue;
      font-size: 1.3rem;
      font-weight: bold;
    }
    ul {
      li {
        text-indent: -38px;
        margin-left: 30px;
        margin-bottom: 1rem;
        font-size: 1.1rem;
        color: steelblue;
        svg {
          margin-right: 12px;
        }
      }
    }
  }
  .example-comment {
    display: block;
    text-indent: 0;
    text-align: center;
    font-size: 4rem;
    color: #27e69d;
    cursor: pointer;
    transition: 0.2s;
    width: 100px;
    margin: 0 auto;
    &:hover {
      color: cadetblue;
    }
  }
  .social-icon {
    font-size: 40px;
    padding-bottom: 2px;
    color: dodgerblue;
    margin-left: 12px;
  }
  .tab-content-heading {
    font-size: 1.4rem;
    font-weight: bold;
    color: steelblue;
    margin: 15px auto 10px;
  }

  .top-level {
    margin: 0 auto 2rem;
    text-align: center;
    h4 {
      margin-bottom: 2rem;
      color: deepskyblue;
      font-size: 1.3rem;
      font-weight: bold;
    }
    .type {
      width: 120px;
      height: 120px;
      border-radius: 50%;
      margin: 0 10px;
      position: relative;
      cursor: pointer;
      transition: 0.25s;
      opacity: 1;
      background: #e5e5e5;
      span {
        position: absolute;
        top: 47%;
        left: 50%;
        transform: translate(-50%, -50%);
        font-size: 1.3rem;
        line-height: 1.4rem;
        color: deepskyblue;
        font-weight: bold;
      }
      &:hover {
        opacity: 0.85;
      }
      display: inline-block;
      &.item {
        background: #45cffd;
        span {
          color: #fff;
        }
      }
      &.service {
        background: #58f98b;
        span {
          color: #fff;
        }
      }
      &.job {
        background: #ba96fd;
        span {
          color: #fff;
        }
      }
    }
  }

  .login-warning {
    h3 {
      margin: 1rem 1rem 10px;
      font-weight: bold;
      color: darkorange;
      font-size: 1.1rem;
    }
    h4 {
      margin: 10px 1rem 2rem;
      color: steelblue;
      font-size: 1.1rem;
    }
  }


</style>












